<template>
  <div id="coin_dealer_rule">
     <!-- 顶部导航栏 -->
    <van-nav-bar placeholder safe-area-inset-top :title="$t('column.Coin_dealer_rule')" @click-left="onClickLeft" left-arrow />
    <van-row>
      <van-col span="24" class="coin_dealer_rule">
        <!-- 规则表格 -->
          <van-col span="24" class="rules-section">
            <van-col span="12" class="rules-title"  @click="rulesTab = 'DepositRules'">
              {{ $t('column.deposit_rules')}}
              <div :class="{'rules-title-active': rulesTab === 'DepositRules'}"></div>
            </van-col>
            <van-col span="12" class="rules-title" @click="rulesTab = 'LevelUpRules'">
              {{ $t('column.level_up_rules')}}
              <div :class="{'rules-title-active': rulesTab === 'LevelUpRules'}"></div>
            </van-col>
          </van-col>
          <!-- 等级规则 -->
          <van-col span="24" class="rules-table" v-if="rulesTab === 'LevelUpRules'">
            <van-col span="22" offset="1" class="table-header">
              <van-col span="6" class="table-cell"></van-col>
              <van-col span="6" class="table-cell table-cell-bor">{{ $t('column.senior_seller')}}</van-col>
              <van-col span="6" class="table-cell table-cell-bor">{{ $t('column.standard_seller')}}</van-col>
              <van-col span="6" class="table-cell table-cell-bor">{{ $t('column.beginner_seller') }}</van-col>
            </van-col>
            <!-- 数据 -->
            <van-col span="22" offset="1" class="table-row-list">
              <van-col span="24" class="table-cell-title">{{ $t('column.exchange_recharge') }}</van-col>
              <!--     exchange       -->
              <van-col  span="24" class="table-row">
                <van-col span="6" class="table-cell">
                  <van-col span="24" class="rule-name-color"> {{ $t('column.exchange') }}</van-col>
                  <van-col span="24" class="rule-name-coin">
                    <img src="../assets/img/coin9.png"/> {{rulesData.exchange.diamond }}=
                    <img src="../assets/img/coin10.png"/> {{rulesData.exchange.coin }}
                  </van-col>
                  <van-col span="24" class="rule-name-from">
                    From  <img src="../assets/img/coin9.png"/> {{rulesData.exchange.from }}
                  </van-col>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="18" v-if="rulesData.exchange.senior_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="18" v-else/>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="18" v-if="rulesData.exchange.standard_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="18" v-else/>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="18" v-if="rulesData.exchange.beginner_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="18" v-else/>
                </van-col>
              </van-col>
              <van-col  span="24" class="table-row">
                <van-col span="6" class="table-cell">
                  <van-col span="24" class="rule-name-color"> {{ $t('column.recharge') }}</van-col>
                  <van-col span="24" class="rule-name-coin">
                    ${{rulesData.recharge.money }}=
                    <img src="../assets/img/coin10.png"/> {{rulesData.recharge.coin }}
                  </van-col>
                  <van-col span="24" class="rule-name-from">
                    {{ $t('column.from')}} ${{rulesData.recharge.from }}
                  </van-col>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.recharge.senior_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.recharge.standard_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.recharge.beginner_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
              </van-col>

              <van-col span="24" class="table-cell-title">{{ $t('column.sales_methods') }}</van-col>
              <!--    sales methods      -->
              <van-col  span="24" class="table-row">
                <van-col span="6" class="table-cell rule-name1">
                  {{ $t('column.coin_seller')}} -> {{ $t('column.user')}}
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.sales_user.senior_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.sales_user.standard_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.sales_user.beginner_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
              </van-col>
              <van-col  span="24" class="table-row">
                <van-col span="6" class="table-cell rule-name1">
                  {{ $t('column.coin_seller')}} -> {{ $t('column.coin_seller')}}
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.sales_coin_seller.senior_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.sales_coin_seller.standard_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.sales_coin_seller.beginner_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
              </van-col>
              <van-col span="24" class="table-cell-title">{{ $t('column.privilege') }}</van-col>
              <!--   privilege     -->
              <van-col  span="24" class="table-row">
                <van-col span="6" class="table-cell rule-name1"> {{ $t('column.seller_list')}} </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.seller_list.senior_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.seller_list.standard_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.seller_list.beginner_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
              </van-col>
              <van-col  span="24" class="table-row">
                <van-col span="6" class="table-cell rule-name1"> {{ $t('column.coin_selling_list')}} </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.coin_selling_list.senior_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.coin_selling_list.standard_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.coin_selling_list.beginner_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
              </van-col>
              <van-col  span="24" class="table-row">
                <van-col span="6" class="table-cell rule-name1"> {{ $t('column.seller_tag')}} </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <img :src="rulesData.seller_tag.senior_seller_tag" v-if="rulesData.seller_tag.senior_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <img :src="rulesData.seller_tag.standard_seller_tag" v-if="rulesData.seller_tag.standard_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <img :src="rulesData.seller_tag.beginner_seller_tag" v-if="rulesData.seller_tag.beginner_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
              </van-col>
            </van-col>
            <van-col span="22" offset="1" class="table-row-usd">*{{ $t('column.recharge_with_usd') }}: $1= <img src="../assets/img/coin10.png"/> {{ recharge_usd_ratio }} </van-col>
          </van-col>
          <van-col span="24" class="rules-table" v-else>
            <van-col span="22" offset="1" class="coin_seller_rules_deposit" v-html="deposit_rules"> </van-col>
          </van-col>
      </van-col>
    </van-row>
  </div>
</template>

<script>

import '@/assets/css/style.css'
import axios from "axios";
import {Toast, Dialog} from "vant";
export default {
  data() {
    return {
        rulesTab: 'LevelUpRules',
        rulesData:{
            exchange:{
                diamond:false,
                coin:false,
                from: 0,
                senior_seller:0,
                standard_seller:0,
                beginner_seller:0
            },
            recharge:{
                money:false,
                coin:false,
                from: 0,
                senior_seller:0,
                standard_seller:0,
                beginner_seller:0
            },
            sales_user:{
                senior_seller:0,
                standard_seller:0,
                beginner_seller:0
            },
             sales_coin_seller:{
                senior_seller:0,
                standard_seller:0,
                beginner_seller:0
            },
            seller_list:{
                senior_seller:false,
                standard_seller:false,
                beginner_seller:false
            },
            customer_recommend_list:{
                senior_seller:false,
                standard_seller:false,
                beginner_seller:false
            },
            coin_selling_list:{
                senior_seller:false,
                standard_seller:false,
                beginner_seller:false
            },
            seller_tag:{
                senior_seller:false,
                standard_seller:false,
                beginner_seller:false,
                senior_seller_tag:'',
                standard_seller_tag:'',
                beginner_seller_tag:''
            }
        },
        deposit_rules:'',
        recharge_usd_ratio:''
    }
  },
  created() {
   this.get_list()
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
     get_list(){
      const toast = this.$toast.loading({
        duration: 0, // 持续展示
        forbidClick: true,
        message: this.$t('other.Loading') + '...',
        className: 'custom-loading-toast' // 添加自定义类名
      });
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=coin_seller&act=coin_dealer_ruler",{
        params:{uid: uid, token: token }
      }).then(res =>{
        toast.clear(); // 关闭加载提示
        console.log(res.data)
        if(res.data.status===1){
          this.rulesData = res.data.data.level_up_rules
          this.deposit_rules = res.data.data.deposit_rules
          this.recharge_usd_ratio = res.data.data.recharge_usd_ratio
        }else{
          Toast(res.data.error)
        }
      })
    }
  }
}

</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/coin_dealer_rule.vue